<div class="page-header-container layout">
  <md-page-header [title]="slaughterHouseData()?.name?.fi ?? ''" icon="partner"></md-page-header>
  <md-info [item]="slaughterHouseData()" [fields]="infoFields()" [pricingRouteLabel]="'INFO.GO_TO_PRICES'" [pricingType]="'slaughterhouse'"> </md-info>
  <md-products-and-fillspots [slaughterhouseItem]="slaughterHouseData()"></md-products-and-fillspots>
  <md-audit-trail [auditTrail]="auditTrail()"></md-audit-trail>
</div>
